// Fabriques de blocs visuels par défaut pour les 3 types « code / géométrie ».
// Utilisées par les boutons d'ajout de l'éditeur (insertion + ouverture du form).

import type { ConstrainedGeometryBlock, PythonCodeBlock, ScratchCodeBlock } from '@jeraisonne/ai';

export function makePythonBlock(order: number): PythonCodeBlock {
  return {
    id: `py-${Date.now()}`,
    type: 'python_code',
    order,
    code: '# Saisis ton code Python ici\nfor i in range(3):\n    print(i)',
    language: 'python',
    showLineNumbers: true,
    highlightLines: [],
  };
}

export function makeScratchBlock(order: number): ScratchCodeBlock {
  return {
    id: `scratch-${Date.now()}`,
    type: 'scratch_code',
    order,
    scripts: [
      [
        {
          id: 'b1',
          category: 'events',
          label: 'quand {0} est cliqué',
          inputs: ['🏁'],
          shape: 'hat',
        },
        { id: 'b2', category: 'motion', label: 'avancer de {0} pas', inputs: [10], shape: 'stack' },
      ],
    ],
  };
}

export function makeConstrainedGeometryBlock(order: number): ConstrainedGeometryBlock {
  return {
    id: `cg-${Date.now()}`,
    type: 'constrained_geometry',
    order,
    points: [
      { id: 'A', name: 'A', x: -2, y: 0, fixed: true },
      { id: 'B', name: 'B', x: 2, y: 0 },
    ],
    constraints: [{ id: 'c1', type: 'distance', a: 'A', b: 'B', value: 5 }],
    drawables: [{ id: 'd1', kind: 'segment', a: 'A', b: 'B', label: 'AB' }],
    interactive: true,
  };
}
